import React, { PureComponent } from 'react';
import { FaBug } from 'react-icons/fa';
import MapButton from './MapButton';

interface TechnicianSidebarButtonProps {
  onClick: () => void;
  toggled: boolean;
}

export default class TechnicianSidebarButton extends PureComponent<TechnicianSidebarButtonProps> {
  render() {
    return (
      <MapButton tooltip="Technician Tools" onClick={this.props.onClick} toggled={this.props.toggled}>
        <FaBug size={22} />
      </MapButton>
    );
  }
}
